import { useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import {
  getArticuloByCodigo,
  getByIdArticulos,
  putArticuloCompuesto,
} from '../../../Services/articuloService'
import { saveError } from '../../../Services/errorService'
import { getAllFamilias } from '../../../Services/familiaService'
import { getAllMarcas } from '../../../Services/marcaService'
import { getAllUnidadMedidas } from '../../../Services/unidadMedidaService'

const emptyFormValues = {
  nombre: '',
  porcentajeGanancia: 0,
  costo: 0.0,
  pesable: false,
  balanza: false,
  descripcion: '',
  precioFinal: 0.0,
  codigo: '',
  puntos: 0,
  pesoPromedio: 0,
  porcentajePerdida: 0,
  familia: '',
  marca: '',
  unidadMedida: '',
}

const mapRecipeToItems = (articulos = []) =>
  articulos.map((a) => ({
    id: a.id,
    codigo: a.codigo,
    articulo: a.nombre,
    costo: a.costo ?? '',
    familia: a.familia ?? { nombre: '-' },
    cantidad: a.cantidad,
  }))

const mapRecipeToSaveItems = (articulos = []) =>
  articulos.map((a) => ({
    id: a.id,
    cantidad: a.cantidad,
  }))

const useEditCompuesto = (history, location, match) => {
  let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
  let rol = token.authorities[0]

  const articuloId = match?.params?.id || location?.state?.articulo?.id
  const seed = location?.state?.articulo

  const [isHydrating, setIsHydrating] = useState(true)
  const [articulo, setArticulo] = useState(seed || null)
  const [itemsCompra, setItemsCompra] = useState([])
  const [items, setItems] = useState([])
  const [codigoArticulo, setCodigoArticulo] = useState()
  const [cantidadArticulo, setCantidadArticulo] = useState(1)
  const [codigosBarra, setCodigosBarra] = useState(seed?.codigosBarra || [])
  const [familias, setFamilias] = useState([])
  const [marcas, setMarcas] = useState([])
  const [unidadMedidas, setUnidadMedidas] = useState([])
  const inputTotalRef = useRef(null)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: articulo
      ? {
          nombre: articulo.nombre,
          porcentajeGanancia: articulo.porcentajeGanancia,
          costo: articulo.costo,
          pesable: articulo.pesable,
          balanza: articulo.balanza,
          descripcion: articulo.descripcion,
          precioFinal: articulo.precioFinal,
          codigo: articulo.codigo,
          puntos: articulo.puntos,
          pesoPromedio: articulo.pesoPromedio,
          porcentajePerdida: articulo.porcentajePerdida ?? 0,
          familia: articulo.familia,
          marca: articulo.marca,
          unidadMedida: articulo.unidadMedida,
        }
      : emptyFormValues,
    validationSchema: Yup.object({
      nombre: Yup.string().required('Obligatorio'),
      costo: Yup.number().required('Obligatorio').min(0),
      precioFinal: Yup.number().min(0, 'El valor debe ser mayor a 0'),
      codigo: Yup.string()
        .matches(/^[0-9]+$/, 'Solo números')
        .required('Obligatorio'),
      familia: Yup.object().required('Obligatorio'),
      marca: Yup.object().required('Obligatorio'),
      unidadMedida: Yup.object().required('Obligatorio'),
      porcentajePerdida: Yup.number()
        .min(0, 'Debe ser entre 0 y 100')
        .max(100, 'Debe ser entre 0 y 100'),
    }),
    onSubmit: (values) => editCompositeArticleSubmit(values),
  })

  useEffect(() => {
    if (rol !== 'ROLE_ADMIN') history.goBack()

    if (!articuloId) {
      Swal.fire({
        title: 'No se pudo cargar el artículo.',
        type: 'error',
        showConfirmButton: false,
        timer: 2000,
      })
      history.goBack()
      return
    }

    getAllFamilias(true, 0, '', 100)
      .then((res) => setFamilias(res.data.content))
      .catch(() => console.log('error'))
    getAllMarcas(true, 0, '', 400)
      .then((res) => setMarcas(res.data.content))
      .catch(() => console.log('error'))
    getAllUnidadMedidas(true, 0, '', 100)
      .then((res) => setUnidadMedidas(res.data.content))
      .catch(() => console.log('error'))

    getByIdArticulos(articuloId, { compuestos: true })
      .then((res) => {
        const data = res.data
        setArticulo(data)
        setCodigosBarra(data.codigosBarra || [])
        const recipe = data.articulos || []
        setItems(mapRecipeToItems(recipe))
        setItemsCompra(mapRecipeToSaveItems(recipe))
        setIsHydrating(false)
      })
      .catch(async (error) => {
        setIsHydrating(false)
        const message =
          error?.response?.data?.message ||
          'No se pudo cargar el artículo compuesto.'
        const errorData = {
          mensaje: 'Error al hidratar un articulo compuesto',
          detalle: message,
          entidad: 'ARTICULO',
          tipo: 'WEBAPP',
          severidad: 'HIGH',
          reportado: 'APPLICATION',
        }
        await saveError(errorData)
        Swal.fire({
          title: 'Error al cargar el artículo compuesto.',
          text: message,
          type: 'error',
          showConfirmButton: false,
          timer: 2500,
        })
        history.goBack()
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCodigosBarra = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      const codigoBarraValue = e.target.value.trim()
      if (codigoBarraValue) {
        let codigoBarra = { codigo: codigoBarraValue }
        setCodigosBarra([...codigosBarra, codigoBarra])
        e.target.value = ''
      }
    }
  }

  const deleteCodigoBarra = (e, codigo) => {
    e.preventDefault()
    let codigosBarraFilter = codigosBarra.filter(function (cv) {
      return cv.codigo !== codigo
    })
    setCodigosBarra(codigosBarraFilter)
  }

  const handleKeyPress = () => {
    let isPresent = false
    items.forEach((item) => {
      if (parseInt(item.codigo, 10) === parseInt(codigoArticulo, 10))
        isPresent = true
    })
    if (isPresent) {
      setCodigoArticulo('')
      setCantidadArticulo(1)
      inputTotalRef.current.focus()
      Swal.fire({
        toast: true,
        position: 'top',
        title: 'El artículo ya se ingresó.',
        type: 'info',
        showConfirmButton: false,
        timer: 1500,
      })
      return
    }
    getArticuloByCodigo(codigoArticulo)
      .then(async (data) => {
        let articuloFound = data.data
        let item = {
          id: articuloFound.id,
          codigo: articuloFound.codigo,
          articulo: articuloFound.nombre,
          costo: articuloFound.costo,
          familia: articuloFound.familia,
          cantidad: parseFloat(cantidadArticulo, 10),
        }
        let itemCompra = {
          id: articuloFound.id,
          cantidad: item.cantidad,
        }
        setItemsCompra([...itemsCompra, itemCompra])
        setItems([...items, item])
        setCodigoArticulo('')
        setCantidadArticulo(1)
        inputTotalRef.current.focus()
      })
      .catch(() => {
        setCodigoArticulo('')
        setCantidadArticulo(1)
        inputTotalRef.current.focus()
        Swal.fire({
          toast: true,
          position: 'top',
          title: 'El artículo no existe.',
          text: 'No se encontró en la base de datos.',
          type: 'info',
          timer: 2000,
          showConfirmButton: false,
        })
      })
  }

  const deleteItem = (articuloItem) => {
    let itemsDelete = items.filter((item) => {
      return parseInt(item.id, 10) !== parseInt(articuloItem.id, 10)
    })
    let itemsCompraDelete = itemsCompra.filter((item) => {
      return parseInt(item.id, 10) !== parseInt(articuloItem.id, 10)
    })
    setItemsCompra(itemsCompraDelete)
    setItems(itemsDelete)
  }

  const editCompositeArticleSubmit = (values) => {
    if (!itemsCompra.length) {
      Swal.fire({
        title: 'La composición no puede estar vacía.',
        type: 'info',
        showConfirmButton: false,
        timer: 2000,
      })
      return
    }

    const {
      nombre,
      costo,
      precioFinal,
      puntos,
      codigo,
      descripcion,
      pesable,
      balanza,
      pesoPromedio,
      porcentajeGanancia,
      porcentajePerdida,
      familia,
      marca,
      unidadMedida,
    } = values

    const isPesable = String(pesable) === 'true'
    let articuloUpdated = {
      nombre,
      costo,
      precioFinal,
      puntos,
      codigo,
      descripcion,
      pesable,
      balanza,
      pesoPromedio,
      compuesto: true,
      porcentajeGanancia,
      porcentajePerdida: isPesable ? Number(porcentajePerdida) || 0 : 0,
      familiaId: familia.id,
      marcaId: marca.id,
      unidadMedidaId: unidadMedida.id,
      codigosBarra,
      articulos: itemsCompra,
    }

    putArticuloCompuesto(articuloId, articuloUpdated)
      .then(() => {
        history.goBack()
      })
      .catch(async (error) => {
        const message =
          error?.response?.data?.message ||
          'Faltan datos o algunos son incorrectos.'
        const errorData = {
          mensaje: 'Error al intentar editar un articulo compuesto',
          detalle: message,
          entidad: 'ARTICULO',
          tipo: 'WEBAPP',
          severidad: 'HIGH',
          reportado: 'APPLICATION',
        }
        await saveError(errorData)
        Swal.fire({
          title: 'No se pudo guardar el artículo compuesto.',
          text: message,
          type: 'error',
          showConfirmButton: false,
          timer: 2500,
        })
      })
  }

  return {
    formik,
    isHydrating,
    items,
    codigoArticulo,
    setCodigoArticulo,
    cantidadArticulo,
    setCantidadArticulo,
    codigosBarra,
    inputTotalRef,
    familias,
    marcas,
    unidadMedidas,
    handleCodigosBarra,
    deleteCodigoBarra,
    handleKeyPress,
    deleteItem,
    editCompositeArticleSubmit,
  }
}

export default useEditCompuesto
